export type EntryStatus = 'used' | 'invalid-date' | 'invalid-locale' | 'unused';

export type EntryInfo = {
    id: string;
    spaceId?: string;
    environment?: string;
    contentType?: string;
    title?: string;
    status: EntryStatus;
};

export function parseMetas(): EntryInfo[] {
    const metas = document.querySelectorAll<HTMLMetaElement>('meta[name="x-contentful-entry"]');
    const seen = new Set<string>();
    const result: EntryInfo[] = [];

    for (const meta of metas) {
        try {
            const data = JSON.parse(atob(meta.content)) as EntryInfo;
            if (data.id && !seen.has(data.id)) {
                seen.add(data.id);
                result.push(data);
            }
        } catch {
            // ignore malformed
        }
    }

    return result;
}

export const ENTRY_STATUS_LABELS: Record<EntryStatus, string> = {
    used: 'Showing',
    'invalid-date': 'Out of Schedule',
    'invalid-locale': 'Wrong Locale',
    unused: 'Not Selected',
};

export const ENTRY_STATUS_ORDER: EntryStatus[] = ['used', 'invalid-date', 'invalid-locale', 'unused'];

export function groupByStatus(entries: EntryInfo[]): Record<EntryStatus, EntryInfo[]> {
    return {
        used: entries.filter(e => e.status === 'used'),
        'invalid-date': entries.filter(e => e.status === 'invalid-date'),
        'invalid-locale': entries.filter(e => e.status === 'invalid-locale'),
        unused: entries.filter(e => e.status === 'unused'),
    };
}

export const SPACE_NAMES: Record<string, string> = {
    '5wrsquke0fbt': 'eCommerce-PetSmart',
    '3wlxlxhjddo7': 'Loyalty PROD',
};

export function spaceName(id: string): string {
    return SPACE_NAMES[id] ?? id;
}

export function entryHref(entry: EntryInfo): string | undefined {
    if (!entry.spaceId) return undefined;
    const envSegment = entry.environment && entry.environment !== 'master' ? `/environments/${entry.environment}` : '';
    return `https://app.contentful.com/spaces/${entry.spaceId}${envSegment}/entries/${entry.id}`;
}
